export default customElements.define('w-button', class Button extends wealthify.CustomElementBaseClass {

    submitCallback = null;
    #styleSelector;

    constructor () {
        const styleSelector = 'c-button';
        const config = {
            styleSelector,
            templateHTML: `
                <button class="${styleSelector}__container" type="button" data-root>
                    <w-icon class="${styleSelector}__icon ${styleSelector}__icon--left" data-iconleft></w-icon>
                    <div class="${styleSelector}__label" data-content></div>
                    <w-icon class="${styleSelector}__icon ${styleSelector}__icon--right" data-iconright></w-icon>
                </button>`,
            cacheDom: [ 'data-content', 'data-iconleft', 'data-iconright' ]
        };

        super(config);

        this.#styleSelector = styleSelector;

        this.onConnectedCallback = () => {
            this.classList.add(this.#styleSelector);
        };
    }

    static get validContexts () {
        return [ 'button', 'submit' ];
    }

    static get validTypes () {
        return [ 'primary', 'secondary', 'tertiary', 'danger' ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('context', {type: wealthify.propTypes.ArrayItem(this.validContexts)}),

            new wealthify.Prop('label', {required: true}),

            new wealthify.Prop('onclickprop', {type: wealthify.propTypes.Function()}),

            new wealthify.Prop('small', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('submitform'),
            new wealthify.Prop('submitformv2'),
            new wealthify.Prop('submitformv3'),
            new wealthify.Prop('submitformv4'),

            new wealthify.Prop('type', {
                default: 'primary',
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            }),

            new wealthify.Prop('fullwidth', {type: wealthify.propTypes.Boolean()}),

            new wealthify.Prop('link'),

            new wealthify.Prop('selected', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            wealthify.props.Disabled(),
            wealthify.props.Icon({
                default: 'no-icon',
                name: 'iconleft'
            }),
            wealthify.props.Icon({
                default: 'no-icon',
                name: 'iconright'
            })
        ];
    }

    get propCallbacks() {
        return {   
            context: () => {
                console.group('Deprecated props');
                console.warn('The context prop is deprecated on the Button component. Please use submitformv2.');
                console.groupEnd();
                
                this.dom.root.setAttribute('type', this.context);
            },
            
            disabledprop: () => {
                const classListAction = this.disabledprop ? 'add' : 'remove';
                
                this.classList[classListAction](`${this.#styleSelector}--disabled`);
                
                if (this.disabledprop) {
                    this.dom.root.setAttribute('disabled', this.disabledprop);
                } else {
                    this.dom.root.removeAttribute('disabled');
                }
            },
            
            label: (value) => {
                this.dom.content.innerHTML = value;    
            },
            
            onclickprop: () =>  this._setOnclick(),

            small: () => {
                const classListAction = this.small ? 'add' : 'remove';

                this.classList[classListAction](`${this.styleSelector}--small`);
            },
            
            submitform: (value) => {
                console.group('Deprecated props');
                console.warn('The submitform prop is deprecated on the Button component. Please use submitformv2.');
                console.groupEnd();

                this.dom.root.setAttribute('form', value);
            },

            submitformv2: () => {
                let type = 'button',
                    onclickprop = this.onclickprop;

                if (this.submitformv2 !== '') {

                    type = 'submit';
                    this.dom.root.setAttribute('form', this.submitformv2);

                    onclickprop = (event) => {
                        event.preventDefault();
                        
                        const form = document.querySelector(`#${this.submitformv2}`);
                        const formValid = form.checkValidity();

                        if (!formValid) {
                            return this._fireValidationAndFocusFirstInvalid(form);
                        }

                        this.disabledprop = true;
                        form.submit();
                    };
                }

                this.dom.root.setAttribute('type', type);
                this.onclickprop = onclickprop;
            },

            submitformv3: () => {
                let type = 'button';

                if (this.submitformv3 !== '') {

                    type = 'submit';
                    this.dom.root.setAttribute('form', this.submitformv3);

                    this.submitCallback = (event) => {
                        event.preventDefault();
                        
                        const form = document.querySelector(`#${this.submitformv3}`);
                        const formValid = form.checkValidity();

                        if (!formValid) {
                            return this._fireValidationAndFocusFirstInvalid(form);
                        }

                        this.disabledprop = true;
                        form.submit();
                    };

                    this._setOnclickV3V4();
                }

                this.dom.root.setAttribute('type', type);
            },

            submitformv4: () => {
                let type = 'button';

                if (this.submitformv4 !== '') {

                    type = 'submit';
                    this.dom.root.setAttribute('form', this.submitformv3);

                    this.submitCallback = (event) => {
                        event.preventDefault();
                        
                        const form = document.querySelector(`#${this.submitformv4}`);
                        const formValid = wealthify.form.validateFieldsAndRefocus(form);

                        if (!formValid) {
                            return;
                        }

                        this.disabledprop = true;
                        form.submit();
                    };

                    this._setOnclickV3V4();
                }

                this.dom.root.setAttribute('type', type);
            },
            
            type: (value) => {
                this.constructor.validTypes.forEach((type) => this.dom.root.classList.remove(`${this.#styleSelector}__container--${type}`));
                this.dom.root.classList.add(`${this.#styleSelector}__container--${value}`);
            },

            fullwidth: (value) => {
                const classListAction = value ? 'add' : 'remove';
                
                this.classList[classListAction](`${this.#styleSelector}--fullwidth`);
                this.dom.root.classList[classListAction](`${this.#styleSelector}__container--fullwidth`);
            },

            link: () => this._setOnclick(),

            selected: () => {
                const classListAction = this.selected ? 'add' : 'remove';
              
                this.dom.root.classList[classListAction](`${this.#styleSelector}__container--${this.type}-selected`);
                this.disabledprop = this.disabledprop || this.selected;
            }
        };
    }

    _setOnclick () {
        const hasOnclickprop = this.onclickprop !== undefined;
        const hasLink = this.link !== undefined;

        let onclickprop = this.onclickprop,
            link = () => window.location.href = this.link;

        if (hasLink && hasOnclickprop) {
            onclickprop = () => {
                window.addEventListener('beforeunload', () => {
                    this.onclickprop();
                });
            };
        }

        this.dom.root.onclick = function (event) {
            if (hasOnclickprop) {
                onclickprop(event);
            }

            if (hasLink) {
                link();
            }
        };
    }

    _setOnclickV3V4 () {
        const hasOnclickprop = this.onclickprop !== undefined;
        const hasLink = this.link !== undefined;
        const hasSubmitCallback = this.submitCallback !== null;

        const shouldFireClickOnPageUnload = (hasLink && hasOnclickprop) && !hasSubmitCallback;

        let onclickprop = this.onclickprop,
            link = hasLink ? () => window.location.href = this.link : null,
            submit = this.submitCallback;

        if (shouldFireClickOnPageUnload) {
            onclickprop = () => {
                window.addEventListener('beforeunload', () => {
                    this.onclickprop();
                });
            };
        }

        this.dom.root.onclick = function (event) {
            if (hasOnclickprop) {
                onclickprop.bind(this)();
            }

            if (hasSubmitCallback) {
                return submit(event);
            }

            if (hasLink) {
                link();
            }
        };
    }

    _fireValidationAndFocusFirstInvalid (form) {
        const invalidFields = Array.prototype.filter.call(form.elements, (element) => element.tagName.toLowerCase() !== 'button' && !element.checkValidity());

        let firstInvalidFieldgroup;

        invalidFields.forEach((field, index) => {

            const fieldComponent = this._getWrappingComponent(field);
            const isDeprecatedComponent = fieldComponent.fireValidation !== undefined;

            if (isDeprecatedComponent){
                fieldComponent.fireValidation();
            } else {
                field.validation.events.FireValidation.dispatch();
            }

            if (index === 0) {
                firstInvalidFieldgroup = isDeprecatedComponent ? this._getWrappingComponent(fieldComponent) : fieldComponent;
            }
        });

        const scrollLocation = window.scrollY + firstInvalidFieldgroup.getBoundingClientRect().top;

        invalidFields[0].focus();
        window.scrollTo({top: scrollLocation});
    }

    _getWrappingComponent (element) {
        return element.getWrappingComponent ? element.getWrappingComponent() : element.parentComponent;
    }

});